import {t} from '../i18n.js';

/**
 * @returns {string}
 * @usage
 * ```
 * <svg class="icon">
 *   <use href="#icon-home" />
 * </svg>
 * ```
 */
export function svgImages() {
    return `
<svg xmlns="http://www.w3.org/2000/svg" id="bookingWidgetIcons" style="display: none;">
    <symbol id="icon-home" viewBox="0 0 24 24" fill="currentColor">
        <path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z"/>
    </symbol>

    <symbol id="icon-user" viewBox="0 0 24 24" fill="currentColor">
        <path d="M12 12c2.67 0 8 1.34 8 4v4H4v-4c0-2.66 5.33-4 8-4zm0-2a4 4 0 1 0 0-8 4 4 0 0 0 0 8z"/>
    </symbol>
    
    <symbol id="icon-back" viewBox="0 0 24 24" fill="currentColor">
        <path d="M10.28 19.28a.75.75 0 01-1.06 0l-7-7a.751.751 0 01-.072-.083h-.001A.742.742 0 012 11.753v-.004-.004a.748.748 0 01.22-.526l7-7 .084-.073a.75.75 0 01.976.073l.073.084a.75.75 0 01-.073.976L4.561 11H20.75l.102.007a.75.75 0 01-.102 1.493H4.561l5.72 5.72.072.084a.75.75 0 01-.073.976z"/>
    </symbol>   
    
    <symbol id="icon-close"  viewBox="0 0 24 24" fill="currentColor">
        <path d="M4.293 4.293a1 1 0 011.414 0L12 10.585l6.293-6.292a1 1 0 011.32-.083l.094.083a1 1 0 010 1.414L13.415 12l6.292 6.293a1 1 0 01.083 1.32l-.083.094a1 1 0 01-1.414 0L12 13.415l-6.293 6.292a1 1 0 01-1.32.083l-.094-.083a1 1 0 010-1.414L10.585 12 4.293 5.707a1 1 0 01-.083-1.32z"/>
    </symbol>
    
    <symbol id="icon-spinner"  viewBox="0 0 512 512" fill="currentColor">
        <path d="M256 48a48 48 0 1 0 0.032 96.032A48 48 0 0 0 256 48M143.008 103.008a40 40 0 0 0 -40 40c0 22.048 17.92 40 40 40 22.048 0 40 -17.952 40 -40 0 -22.08 -17.952 -40 -40 -40m226 24c-8.816 0 -16 7.184 -16 16s7.184 16 16 16 16 -7.2 16 -16c0 -8.816 -7.2 -16 -16 -16M96 220a36 36 0 1 0 0.016 72.016A36 36 0 0 0 96 220m320 16c-11.056 0 -20 8.944 -20 20s8.944 20 20 20 20 -8.944 20 -20 -8.944 -20 -20 -20M143.008 337.008c-17.696 0 -32 14.304 -32 32s14.304 32 32 32 32 -14.32 32 -32c0 -17.696 -14.32 -32 -32 -32m226 8a24 24 0 1 0 0 48 24 24 0 0 0 0 -48M256 388c-15.44 0 -28 12.56 -28 28s12.56 28 28 28 28 -12.56 28 -28 -12.56 -28 -28 -28"/>
    </symbol>
    
    <symbol id="icon-review" viewBox="0 0 40 40" fill="#FFC830">
        <path d="M19.999774 33.530115l-8.589828 4.411935c-1.701434.873896-3.805853.23481-4.70035-1.42744-.356193-.661916-.479106-1.420089-.349712-2.157144l1.640511-9.344628-6.949316-6.617902c-1.37649-1.310845-1.404655-3.46366-.06291-4.808448.53429-.535502 1.234371-.883995 1.991862-.99153l9.60372-1.363363 4.294913-8.502024c.850717-1.684043 2.937728-2.37547 4.66147-1.544344.686403.330958 1.24199.87375 1.58075 1.544344l4.294914 8.502024 9.60372 1.363363c1.90226.270048 3.22027 1.995539 2.943855 3.85399-.11007.740045-.466778 1.424003-1.014904 1.945988l-6.949316 6.617902 1.64051 9.344628c.324946 1.850942-.94749 3.60878-2.842066 3.926242-.75443.126415-1.530475.006332-2.207995-.341658l-8.589828-4.411935z"/>
    </symbol>
  
    <symbol id="icon-facebook" viewBox="0 0 20 20" fill="none">
        <path fill="#007AF8" d="M20 10c0-5.52-4.48-10-10-10S0 4.48 0 10c0 4.84 3.44 8.87 8 9.8V13H6v-3h2V7.5C8 5.57 9.57 4 11.5 4H14v3h-2c-.55 0-1 .45-1 1v2h3v3h-3v6.95c5.05-.5 9-4.76 9-9.95z"/>
    </symbol>
    
    <symbol id="icon-google" viewBox="0 0 24 24" fill="none">
        <path fill="#5384EC" d="M20.061 12.381c0-.557-.045-1.117-.141-1.664h-7.728v3.154h4.426a3.792 3.792 0 01-1.638 2.49v2.047h2.64c1.55-1.427 2.441-3.534 2.441-6.027z"/>
        <path fill="#35A753" d="M12.193 20.386c2.21 0 4.073-.726 5.43-1.978l-2.64-2.047c-.734.5-1.683.783-2.787.783-2.138 0-3.95-1.442-4.6-3.38H4.872v2.11a8.194 8.194 0 007.32 4.512z"/>
        <path fill="#FBBB07" d="M7.593 13.763a4.907 4.907 0 010-3.137v-2.11H4.87a8.2 8.2 0 000 7.357l2.722-2.11z"/>
        <path fill="#EB4334" d="M12.193 7.243a4.452 4.452 0 013.143 1.228l2.338-2.34a7.874 7.874 0 00-5.481-2.13 8.191 8.191 0 00-7.321 4.515l2.72 2.11c.648-1.941 2.463-3.383 4.6-3.383z"/>
    </symbol> 
</svg>
    `
}

export function renderHeader({ currentStep = 1, totalSteps = 4, titleKey = 'stepTitleServices' }) {
    return `
    <div id="booking-header">
      <div class="header-holder">
        <div class="booking-header-top">
          <button class="btn-header step-back-btn">
            <svg class="icon"><use xlink:href="#icon-back"></use></svg>
          </button>
          <h6 class="step-nr">${t('step_of_total', { current: currentStep, total: totalSteps })}</h6>
          <button class="btn-header step-close-btn">
            <svg class="icon"><use xlink:href="#icon-close"></use></svg>
          </button>
        </div>
        <h2 id="booking-step-title">${t(titleKey)}</h2>
      </div>
    </div>
  `;
}

export function renderBottomBar({ maxServices = 3 }) {
    return `
    <div class="sticky-bottom">
      <div class="booking-schedule-bar">
        <a href="" class="primary-button">${t('schedule_now')}</a>
      </div>
      <div class="services-limit-section">
        <p>${t('max_services_allowed', { limit: maxServices })}</p>
      </div>
    </div>
  `;
}

export function renderCategoryLink({ id, name }) {
    return `<li><a href="#category${id}">${name}</a></li>`;
}

export function renderServiceItem({ service, isActive, isDisabled, showDescription, showTime, showPrice }) {
    // Helper to format service time in minutes
    function formatServiceTime(time) {
        if (!time || isNaN(time)) return '';

        if (time >= 60) {
            const hours = Math.floor(time / 60);
            const minutes = time % 60;

            if (minutes === 0) {
                return t('service_duration.hours_only', {
                    hours,
                    hour_label: hours === 1 ? t('time.hour_singular') : t('time.hour_plural')
                });
            }

            return t('service_duration.hours_minutes', {
                hours,
                hour_label: hours === 1 ? t('time.hour_singular') : t('time.hour_plural'),
                minutes,
                minute_label: t('time.minutes')
            });
        }

        return t('service_duration.minutes_only', {
            minutes: time,
            minute_label: t('time.minutes')
        });
    }
// ${showTime ? `<div class="item-time">${t('duration', { time: service.time})}</div>` : ''}
    return `
    <li class="step-category-list-item${isActive ? ' active' : ''}${isDisabled ? ' disabled' : ''}"
        data-service-id="${service.id}"
        ${isDisabled ? ' data-disabled="true"' : ''}>
      <div class="item-button">✔</div>
      <div class="item-body">
        <div class="item-name">${service.name}</div>
        ${showDescription && service.description ? `<div class="item-description">${service.description}</div>` : ''}
        
        ${showTime ? `<div class="item-time">${formatServiceTime(service.time)}</div>` : ''}
      </div>
      ${showPrice && service.cost > 0 ? `<div class="item-price">${service.cost} RON</div>` : ''}
    </li>
  `;
}

export function renderCategoryWrapper({ id, name, serviceListHtml, isMultiple }) {
    return `
    <div class="step-category-wrapper">
      <div class="step-category-title" id="category${id}">${name}</div>
      <ul class="step-category-list" data-category-id="${id}" ${isMultiple ? 'data-multiple' : ''}>
        ${serviceListHtml}
      </ul>
    </div>
  `;
}

export function renderCategoriesContainer({ categoryLinksHtml, categoriesHtml, categoryCount }) {
    return `
    <div id="booking-step-services" data-step="1" class="booking-step active categories-count-${categoryCount}">
      <div class="step-multiple-categories-row">
        <div class="step-multiple-categories-slider">
          <button class="step-categories-slider-prev">←</button>
          <ul class="step-multiple-categories-list">
            ${categoryLinksHtml}
          </ul>
          <button class="step-categories-slider-next">→</button>
        </div>
      </div>
      <div class="step-main-row">
        ${categoriesHtml}
      </div>
    </div>
  `;
}

export function renderLocationsContainer({ locationsHtml }) {
    return `
    <div id="booking-step-locations" data-step="0" class="booking-step active">
        <div class="step-main-row">
            <div class="step-specialist-list">
                ${locationsHtml}
            </div>
        </div>
    </div>
    `;
}

export function renderLocationItem({ location }) {
    return `
    <div class="step-specialist-block justify-content-between" data-location-id="${location.id}">
      <div class="step-specialist-body flex-grow-1">
        <p class="step-specialist-name">${location.name}</p>
        <p class="step-specialist-job">${location.address}</p>
      </div>
      <div class="step-specialist-arrow"></div>
    </div>
  `;
}

export function renderEmployeesContainer({ employeesHtml }) {
  return `
  <div id="booking-step-employees" data-step="2" class="booking-step active">
    <div class="step-main-row">
      <div class="step-specialist-list">
        ${employeesHtml}
      </div>
    </div>
  </div>
`;
}

export function renderEmployeeItem({ employee, servicesHtml, rating }) {
    return `
    <div class="step-specialist-block justify-content-between" data-specialist-id="${employee.id}">
      <div class="step-specialist-image">
        <img src="${employee.avatar}" alt="Image of ${employee.name}" />
      </div>
      <div class="step-specialist-body flex-grow-1">
        <p class="step-specialist-name">${employee.name}</p>
        ${servicesHtml}
      </div>
      ${rating !== null ? `
      <div class="step-specialist-review">
        <svg viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg">
          <path d="M19.999774 33.530115l-8.589828 4.411935c-1.701434.873896-3.805853.23481-4.70035-1.42744-.356193-.661916-.479106-1.420089-.349712-2.157144l1.640511-9.344628-6.949316-6.617902c-1.37649-1.310845-1.404655-3.46366-.06291-4.808448.53429-.535502 1.234371-.883995 1.991862-.99153l9.60372-1.363363 4.294913-8.502024c.850717-1.684043 2.937728-2.37547 4.66147-1.544344.686403.330958 1.24199.87375 1.58075 1.544344l4.294914 8.502024 9.60372 1.363363c1.90226.270048 3.22027 1.995539 2.943855 3.85399-.11007.740045-.466778 1.424003-1.014904 1.945988l-6.949316 6.617902 1.64051 9.344628c.324946 1.850942-.94749 3.60878-2.842066 3.926242-.75443.126415-1.530475.006332-2.207995-.341658l-8.589828-4.411935z"
            fill="#FFC830" fill-rule="evenodd"/>
        </svg>
        <p class="step-specialist-rating">${rating}</p>
      </div>
      ` : ''}
      <div class="step-specialist-arrow"></div>
    </div>
  `;
}
export function renderEmployeeServices({ employee }) {
    return `<p class="step-specialist-job">${employee.specialistJob.map(s => s.name).join(' <b>&#9733;</b> ')}</p>`
}

export function renderTimeSlot({startAt, endAt, index}) {
    return `
        <button class="btn btn-secondary" data-id="${index}">
            <span class="startAtRemove">${startAt}</span>
<!--            <span class="endAt d-none">${endAt}</span>-->
        </button>
    `
}

export function renderCalendarContainer() {
    return `
        <div id="booking-step-calendar" data-step="3" class="booking-step active">
            <div class="step-calendar-row">
                <div class="spinner-overlay" style="display:none;">
                    <svg class="icon fa-spin"><use xlink:href="#icon-spinner"></use></svg>
                </div>
                <div class="step-calendar-columns">
                    <div class="col-date">
                        <h3 class="my-3">${t('choose_date')}</h3>
                        <div class="d-fl-ex justify-content-center flat-picker-wrapper">
                            <div id="flat-picker" class="flat-picker-container"></div>
                        </div>
                    </div>
                    <div class="col-time">
                        <h3 class="my-3">${t('choose_time')}</h3>
                        <div class="booking-list-holder d-flex scheduler justify-content-center" style="flex-direction: column;">

                            <h5 class="booking-list-title">${t('choose_date_from_the_calendar')}</h5>
                            <div class="booking-list-container">
                            </div>
                            <button class="btn btn-confirm" disabled>${t('confirm')}</button>
                        </div>
                    </div>
                </div>
                <div class="step-no-calendar">
                    <h5 class="text-center">${t('calendar_no_dates')}</h5>
                </div>
            </div>
        </div>
    `
}

export function renderConfirmationContainer({config, isClass}) {
    const rawTerms = config.terms_and_conditions_formatted ?? config.terms_and_conditions;
    const terms = !rawTerms ? '' : `
            <p style="margin-bottom: 15px; text-align: left; font-weight: normal;">
                ${rawTerms}
            </p>
    `;
    const message = (!config.allow_messages || isClass) ? '' : `
            <div class="confirmation-message">
                <div class="form-row m-0 mb-3 text-left">
                    <label for="notes">${config.message_field_title || t('extra_notes_default_title')}</label>
                    <textarea required name="notes" id="notes" rows="2"
                              placeholder=" ${t('extra_notes_textarea_placeholder')}"></textarea>
                </div>
            </div>
    `;
    const title = isClass ? t('confirm_your_class') : t('confirm_your_order');
    return `
    <div id="booking-step-confirmation" data-step="5" class="booking-step active">
        <div class="step-confirmation-row grid">
            <h2 class="text-left">${title}</h2>
            <div class="confirmation-details d-none">
                <!-- will be filled by script -->
            </div>

            <table class="table table-sm table-borderless table-striped table-hover text-left confirmation-details-table">
                <!-- will be filled by script -->
            </table>

            ${message}

            ${terms}

            <p class="field-error field-generic-error" style="display:none;"></p>

            <button class="primary-button save-rating" id="send-appointment">
                ${config.use_deposit ? t('finish_with_deposit') : t('finish')}
            </button>
        </div>
    </div>`;
}

export function renderAppointmentDetailsTable({table, state}) {
    let data = state.appointmentSummaryData
    let date = new Date(state.date);
    let dateStr = date.toLocaleString(data.lng ?? "ro-RO", {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
    });

    table.empty();

    if(state.isClass) {
        // Service first
        if (data.services && data.services.length > 0) {
            table.append(`<tr><th class="text-left text-nowrap">${t('class_service')}:</th><td>${data.services.join(", ")}</td></tr>`);
        }
        if (data.employ) {
            table.append(`<tr><th class="text-left text-nowrap">${t('class_specialist')}:</th><td>${data.employ}</td></tr>`);
        }
        table.append(`<tr><th class="text-left text-nowrap">${t('date_of_service')}:</th><td>${dateStr}</td></tr>`);
        table.append(`<tr><th class="text-left text-nowrap">${t('time_of_service')}:</th><td>${state.startAt}-${state.endAt}</td></tr>`);
    } else {
        if (data.employ) {
            table.append(`<tr><th class="text-left text-nowrap">${t('specialist')}:</th><td>${data.employ}</td></tr>`);
        }
        table.append(`<tr><th class="text-left text-nowrap">${t('date_of_service')}:</th><td>${dateStr}</td></tr>`);
        table.append(`<tr><th class="text-left text-nowrap">${t('time_of_service')}:</th><td>${state.startAt}-${state.endAt}</td></tr>`);
        if (data.services && data.services.length > 0) {
            table.append(`<tr><th class="text-left text-nowrap">${t('service')}:</th><td>${data.services.join(", ")}</td></tr>`);
        }
    }
}

export function renderThanksContainer({isClass}) {
    return `
        <div class="step-confirmation-row">
            <p>${t(isClass ? 'thank_you_class' : 'thank_you')}</p>
            
            <table class="table table-sm table-borderless table-striped table-hover text-left appointment-details-table">
                <!-- will be filled by script -->
            </table>
            
            <button class="primary-button save-rating" id="thank-button">${t('thank_button')}</button>
        </div>
    `;
}


